import { Link } from "react-router-dom";

const stats = [
  { value: "500+", label: "每日更新内容" },
  { value: "60万+", label: "累计访问用户" },
  { value: "4", label: "活跃交流版块" },
];

export default function AboutStrip() {
  return (
    <section className="overflow-hidden rounded-lg border border-background-200 bg-secondary-100">
      <div className="flex flex-col gap-8 p-6 md:p-10 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-xl">
          <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-fire-line" aria-hidden="true"></i>
            关于天天干天天干
          </span>
          <h2 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">
            一个持续更新的多元化娱乐社区
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们汇集影视、音乐、游戏等领域的优质内容，用清晰的信息层级与热闹的社区氛围，
            让每一位娱乐爱好者都能快速找到感兴趣的话题，也能轻松分享自己的观点。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解我们
            </Link>
            <Link
              to="/contact"
              className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 lg:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-50 px-4 py-5 text-center md:px-6"
            >
              <p className="text-xl font-bold text-primary-600 md:text-2xl">{stat.value}</p>
              <p className="mt-1 text-xs text-foreground-500 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}